/* Settle Supply Co. - demand-test intent tracking (v4 draft 167064142070).
   No payment is ever taken. The tap on "Add to cart" swaps to Sold out + optional email.
   Fires, once per product per browser session:
     - Shopify customer event  demand_test_add_to_cart (Shopify.analytics.publish)
     - Meta standard AddToCart (only if window.fbq exists on the page)
     - window.dataLayer push (only if dataLayer exists)
     - optional real /cart/add.js (fires Shopify-native product_added_to_cart, which Shopify
       Analytics "Added to cart" and the Facebook & Instagram app pixel read), followed by
       /cart/clear.js so no cart / checkout path is left behind.
   After a confirmed email signup (?customer_posted=true on return) fires demand_test_lead +
   Meta Lead (guarded) + dataLayer.
   Variants (Size/Pack): if the block renders #ss-pills (radio options carrying data-variant-id /
   data-price / data-money / data-sub / data-slug / data-title), the selected option drives
   #ss-atc data-variant-id / data-price, the button label ("/mo" for subscribe), the theme price
   block, the waitlist tag (waitlist,<handle>,<variant-slug>), and every event + the cart add.
   Single-variant products (no #ss-pills) behave exactly as before. */
(function () {
  'use strict';
  var REAL_CART_ADD = true;      // set false to disable the Shopify-native cart add
  var SYNC_THEME_PRICE = true;   // keep the theme's price block in step with the selected variant
  var CLEAR_DELAY_MS = 1500;     // let Shopify's pixel manager read the add response first
  var PENDING_CLEAR = 'ss_dt_clear_pending';
  var PENDING_LEAD = 'ss_dt_lead_pending';

  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }
  function fbqTrack(name, data) {
    try { if (typeof window.fbq === 'function') window.fbq('track', name, data); } catch (e) {}
  }
  function dlPush(obj) {
    try { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(obj); } catch (e) {}
  }

  function clearCart() {
    try {
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: '{}',
        credentials: 'same-origin',
        keepalive: true
      }).then(function (r) { if (r.ok) ssDel(PENDING_CLEAR); }).catch(function () {});
    } catch (e) {}
  }

  // Safety net: if a previous page was closed before the clear ran, empty the cart now.
  if (ssGet(PENDING_CLEAR)) clearCart();

  var root = document.getElementById('ss-atc');
  var btn = document.getElementById('ss-btn');
  var wl = document.getElementById('ss-wl');
  if (!root || !btn) return;

  var d = root.dataset || {};
  var info = {
    product_id: d.productId || '',
    product_handle: d.handle || '',
    product_title: d.title || '',
    variant_id: d.variantId || '',
    price: parseFloat(d.price) || 0,
    currency: d.currency || 'USD'
  };
  var SOLD_BTN = 'Sold out';

  // ---- Variant pills (only when the block rendered them) ----
  var pills = document.getElementById('ss-pills');
  var radios = pills ? Array.prototype.slice.call(pills.querySelectorAll('input[type="radio"][data-variant-id]')) : [];
  var tagInput = wl ? wl.querySelector('input[name="contact[tags]"]') : null;
  var priceBox = null;
  if (radios.length) {
    info.variant_title = d.variantTitle || '';
    info.subscription = d.sub === '1';
    if (SYNC_THEME_PRICE) {
      var scope = root.closest ? root.closest('.product__info-container, .product__info-wrapper, section') : null;
      priceBox = (scope && scope.querySelector('[id^="price-"]')) || null;
    }
  }

  function slugify(t) {
    return String(t || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function fmtMoney(price, money) {
    return money || ('$' + (Number(price) || 0).toFixed(2));
  }
  function syncThemePrice(label) {
    if (!priceBox) return;
    var els = priceBox.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-ss-suffix') === null) {
        var m = el.textContent.trim().match(/\s[A-Z]{3}$/);   // e.g. " USD" from money_with_currency
        el.setAttribute('data-ss-suffix', m ? m[0] : '');
      }
      el.textContent = label.money + el.getAttribute('data-ss-suffix') + label.per;
    }
  }
  function selectVariant(input) {
    if (!input) return;
    var od = input.dataset;
    var sub = od.sub === '1';
    info.variant_id = od.variantId || '';
    info.price = parseFloat(od.price) || 0;
    info.variant_title = od.title || '';
    info.subscription = sub;
    root.setAttribute('data-variant-id', info.variant_id);
    root.setAttribute('data-price', od.price || '');
    root.setAttribute('data-variant-title', info.variant_title);
    root.setAttribute('data-sub', sub ? '1' : '0');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      r.checked = (r === input);
      var lab = r.closest ? r.closest('label') : null;
      if (lab) lab.classList.toggle('is-on', r === input);
    }
    var money = fmtMoney(od.price, od.money);
    var per = sub ? '/mo' : '';
    if (!btn.disabled) btn.textContent = 'Add to cart · ' + money + per;
    if (tagInput && info.product_handle) {
      tagInput.value = 'waitlist,' + info.product_handle + ',' + (od.slug || slugify(info.variant_title));
    }
    syncThemePrice({ money: money, per: per });
  }
  function radioFor(variantId) {
    for (var i = 0; i < radios.length; i++) if (radios[i].dataset.variantId === String(variantId)) return radios[i];
    return null;
  }
  if (radios.length) {
    pills.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('input[type="radio"][data-variant-id]') && !btn.disabled) selectVariant(t);
    });
    var initial = null;
    for (var ri = 0; ri < radios.length; ri++) if (radios[ri].checked) { initial = radios[ri]; break; }
    selectVariant(initial || radioFor(info.variant_id) || radios[0]);
  }

  function showSold() {
    btn.textContent = SOLD_BTN;
    btn.disabled = true;
    if (wl) wl.hidden = false;
    if (radios.length) {
      pills.disabled = true;
      for (var i = 0; i < radios.length; i++) radios[i].disabled = true;
    }
  }

  // Returning from a successful email signup: show a thank-you and record the Lead once.
  var pendingLead = ssGet(PENDING_LEAD);
  if (pendingLead && /[?&]customer_posted=true/.test(window.location.search)) {
    var lead = null;
    try { lead = JSON.parse(pendingLead); } catch (e) {}
    ssDel(PENDING_LEAD);
    if (lead && lead.product_id === info.product_id) {
      if (radios.length && lead.variant_id) selectVariant(radioFor(lead.variant_id));
      var leadKey = 'ss_dt_lead_' + info.product_id;
      if (!ssGet(leadKey)) {
        ssSet(leadKey, '1');
        publish('demand_test_lead', info);
        fbqTrack('Lead', { content_ids: [String(info.variant_id)], content_name: info.product_title });
        dlPush({ event: 'demand_test_lead', ecommerce: { currency: info.currency, value: info.price,
          items: [dlItem()] } });
      }
      showSold();
      if (wl) {
        var p = wl.querySelector('p');
        if (p) p.textContent = "Thanks, you're on the list. Nothing was charged.";
        var f = wl.querySelector('form');
        if (f) f.hidden = true;
      }
    }
  }

  function dlItem() {
    var it = { item_id: String(info.variant_id), item_name: info.product_title, price: info.price, quantity: 1 };
    if (info.variant_title) it.item_variant = info.variant_title;
    return it;
  }

  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    var checked = null;
    for (var ci = 0; ci < radios.length; ci++) if (radios[ci].checked) { checked = radios[ci]; break; }
    if (checked && checked.dataset.variantId !== String(info.variant_id)) selectVariant(checked);
    showSold();

    var atcKey = 'ss_dt_atc_' + info.product_id;
    if (ssGet(atcKey)) return;          // already recorded for this product this session
    ssSet(atcKey, String(Date.now()));

    publish('demand_test_add_to_cart', info);
    fbqTrack('AddToCart', {
      content_ids: [String(info.variant_id)],
      content_type: 'product',
      value: info.price,
      currency: info.currency
    });
    dlPush({ event: 'add_to_cart', demand_test: true, ecommerce: { currency: info.currency, value: info.price,
      items: [dlItem()] } });

    if (REAL_CART_ADD && info.variant_id && window.fetch) {
      ssSet(PENDING_CLEAR, '1');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(info.variant_id), quantity: 1 }] }),
        credentials: 'same-origin'
      }).catch(function () {}).then(function () {
        setTimeout(clearCart, CLEAR_DELAY_MS);
      });
    }
  });

  // Email form: remember which product it was for; the Lead fires only after Shopify confirms
  // the signup (customer_posted=true), so captcha failures are not counted. Submission itself
  // is left untouched so Shopify's hCaptcha handling keeps working.
  var form = wl ? wl.querySelector('form') : null;
  if (form) {
    form.addEventListener('submit', function () {
      var pl = { product_id: info.product_id, t: Date.now() };
      if (radios.length) { pl.variant_id = info.variant_id; pl.variant_title = info.variant_title; }
      ssSet(PENDING_LEAD, JSON.stringify(pl));
    }, true);
  }
})();
